import { type FC } from 'react'
import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IAudioPlayerErrorProps = {
  onRetry: () => void
}

export const AudioPlayerError: FC<IAudioPlayerErrorProps> = ({ onRetry }) => {
  return (
    <div className={styles.wrap}>
      <Typography
        className={styles.errorWrap}
        tag={'div'}
        variant={'body-md-regular'}
        ariaLabel={'title_error'}
      >
        <Icon className={styles.errorWrap__icon} icon={'close'} />
        <span>Failed to load</span>
      </Typography>

      <Typography
        tag={'div'}
        variant={'body-md-medium'}
        className={styles.link}
        onClick={onRetry}
        ariaLabel={'link'}
      >
        Retry
      </Typography>
    </div>
  )
}
